export const formatQty = (value) => Number(value || 0).toFixed(2);

export const TODAY_QTY_DETAIL_COLUMNS = [
  { key: 'dcNo', label: 'DC No' },
  { key: 'date', label: 'Date' },
  { key: 'time', label: 'Time' },
  { key: 'plant', label: 'Plant' },
  { key: 'customer', label: 'Customer' },
  { key: 'site', label: 'Site' },
  { key: 'grade', label: 'Grade' },
  { key: 'deliveryMode', label: 'Mode of Delivery' },
  { key: 'dcQty', label: 'DC Qty', align: 'right' },
  { key: 'acceptedQty', label: 'Accepted Qty', align: 'right' },
];

export const TODAY_QTY_SUMMARY_COLUMNS = [
  { key: 'customer', label: 'Customer' },
  { key: 'site', label: 'Site' },
  { key: 'grade', label: 'Grade' },
  { key: 'dcQty', label: 'DC Qty', align: 'right' },
  { key: 'acceptedQty', label: 'Accepted Qty', align: 'right' },
  { key: 'loadCount', label: 'No. of Load', align: 'right' },
  { key: 'marketing', label: 'Marketing' },
];

export function mapDeliveryChallanForTodayQty(dc) {
  const salesOrder = dc.work_schedule?.sales_order_detail?.sales_order;
  const isActive = dc.status === true || dc.status === 1;
  const dcNo = dc.prefix
    ? `${dc.prefix}/${dc.delivery_challan_no || ''}`
    : (dc.delivery_challan_no || '-');
  return {
    id: dc.id,
    dcNo,
    time: dc.delivery_challan_time || '-',
    plant: dc.work_schedule?.plant?.alias_name || dc.production_plant?.alias_name || '-',
    delivery_challan_date: dc.delivery_challan_date,
    customer: salesOrder?.consignee?.customer?.name || '-',
    site: salesOrder?.consignee?.project_name || '-',
    grade: dc.work_schedule?.sales_order_detail?.product?.name || '-',
    dc_qty: Number(dc.dc_qty) || 0,
    accepted_qty: Number(dc.accepted_qty) || 0,
    marketing: salesOrder?.consignee?.customer?.salesrep?.name || '-',
    deliveryMode: (dc.work_schedule?.delivery_mode || '-').toString().toUpperCase(),
    is_inactive: !isActive,
  };
}

export function buildTodayQtyDetailRows(records) {
  return (records || [])
    .filter((row) => !row.is_inactive)
    .map((row) => ({
      dcNo: row.dcNo || '-',
      date: row.delivery_challan_date || '-',
      time: row.time || '-',
      plant: row.plant || '-',
      customer: row.customer || '-',
      site: row.site || '-',
      grade: row.grade || '-',
      deliveryMode: row.deliveryMode || '-',
      dcQty: Number(row.dc_qty) || 0,
      acceptedQty: Number(row.accepted_qty) || 0,
      loadCount: 1,
    }))
    .sort((left, right) => (
      String(right.date).localeCompare(String(left.date))
      || String(left.dcNo).localeCompare(String(right.dcNo))
    ));
}

export function formatTodayQtyDetailDisplayRows(detailRows) {
  return (detailRows || []).map((row) => ({
    ...row,
    dcQty: formatQty(row.dcQty),
    acceptedQty: formatQty(row.acceptedQty),
  }));
}

export function buildTodayQtySummaryRows(records) {
  const groups = new Map();

  (records || []).forEach((row) => {
    if (row.is_inactive) {
      return;
    }
    const customer = row.customer || '-';
    const site = row.site || '-';
    const grade = row.grade || '-';
    const marketing = row.marketing || '-';
    const key = `${customer}|${site}|${grade}|${marketing}`;
    const dcQty = Number(row.dc_qty) || 0;
    const acceptedQty = Number(row.accepted_qty) || 0;

    if (!groups.has(key)) {
      groups.set(key, {
        customer,
        site,
        grade,
        marketing,
        dcQty: 0,
        acceptedQty: 0,
        loadCount: 0,
      });
    }

    const group = groups.get(key);
    group.dcQty += dcQty;
    group.acceptedQty += acceptedQty;
    group.loadCount += 1;
  });

  return Array.from(groups.values()).sort((left, right) => (
    left.customer.localeCompare(right.customer)
    || left.site.localeCompare(right.site)
    || left.grade.localeCompare(right.grade)
    || left.marketing.localeCompare(right.marketing)
  ));
}

export const TODAY_QTY_MODE_SUMMARY_COLUMNS = [
  { key: 'date', label: 'Date' },
  { key: 'customer', label: 'Customer' },
  { key: 'site', label: 'Site' },
  { key: 'grade', label: 'Grade' },
  { key: 'deliveryMode', label: 'Mode of Delivery' },
  { key: 'dcQty', label: 'DC Qty', align: 'right' },
  { key: 'acceptedQty', label: 'Accepted Qty', align: 'right' },
  { key: 'loadCount', label: 'No. of Load', align: 'right' },
];

export function buildTodayQtyModeSummaryRows(records) {
  const groups = new Map();

  (records || []).forEach((row) => {
    if (row.is_inactive) {
      return;
    }
    const date = row.delivery_challan_date || '-';
    const customer = row.customer || '-';
    const site = row.site || '-';
    const grade = row.grade || '-';
    const deliveryMode = (row.deliveryMode || '-').toString().toUpperCase();
    const key = `${date}|${customer}|${site}|${grade}|${deliveryMode}`;

    if (!groups.has(key)) {
      groups.set(key, {
        date,
        customer,
        site,
        grade,
        deliveryMode,
        dcQty: 0,
        acceptedQty: 0,
        loadCount: 0,
      });
    }

    const group = groups.get(key);
    group.dcQty += Number(row.dc_qty) || 0;
    group.acceptedQty += Number(row.accepted_qty) || 0;
    group.loadCount += 1;
  });

  return Array.from(groups.values()).sort((left, right) => (
    left.date.localeCompare(right.date)
    || left.customer.localeCompare(right.customer)
    || left.site.localeCompare(right.site)
    || left.grade.localeCompare(right.grade)
    || left.deliveryMode.localeCompare(right.deliveryMode)
  ));
}

export function formatTodayQtyModeSummaryDisplayRows(summaryRows) {
  return (summaryRows || []).map((row) => ({
    date: row.date,
    customer: row.customer,
    site: row.site,
    grade: row.grade,
    deliveryMode: row.deliveryMode,
    dcQty: formatQty(row.dcQty),
    acceptedQty: formatQty(row.acceptedQty),
    loadCount: row.loadCount,
  }));
}

export function formatTodayQtySummaryDisplayRows(summaryRows) {
  return (summaryRows || []).map((row) => ({
    customer: row.customer,
    site: row.site,
    grade: row.grade,
    dcQty: formatQty(row.dcQty),
    acceptedQty: formatQty(row.acceptedQty),
    loadCount: row.loadCount,
    marketing: row.marketing,
  }));
}

export function buildTodayQtySummaryTotals(summaryRows) {
  return (summaryRows || []).reduce(
    (totals, row) => ({
      dcQty: totals.dcQty + (Number(row.dcQty) || 0),
      acceptedQty: totals.acceptedQty + (Number(row.acceptedQty) || 0),
      loadCount: totals.loadCount + (Number(row.loadCount) || 0),
    }),
    { dcQty: 0, acceptedQty: 0, loadCount: 0 },
  );
}
